export const clampInteger = (value, minimum, maximum, fallback) => {
    const parsedValue = Number.parseInt(value, 10);
    const safeValue = Number.isFinite(parsedValue) ? parsedValue : fallback;

    return Math.min(maximum, Math.max(minimum, safeValue));
};

export const parseBoolean = (value, fallback = false) => {
    if (typeof value === 'boolean') return value;
    if (typeof value === 'number') return value === 1;
    if (typeof value !== 'string') return fallback;

    const normalizedValue = value.trim().toLowerCase();

    if (['true', '1', 'yes', 'on'].includes(normalizedValue)) return true;
    if (['false', '0', 'no', 'off', ''].includes(normalizedValue)) return false;

    return fallback;
};

export const getHeroSliderSettings = ({
    slideCount = 0,
    autoplay = false,
    autoplayDelay = 5500,
    transitionDuration = 900,
    pauseOnHover = true,
    reducedMotion = false,
} = {}) => {
    const normalizedSlideCount = Math.max(0, Number.parseInt(slideCount, 10) || 0);
    const hasMultipleSlides = normalizedSlideCount > 1;
    const prefersReducedMotion = parseBoolean(reducedMotion);
    const autoplayRequested = hasMultipleSlides && parseBoolean(autoplay);

    return {
        slideCount: normalizedSlideCount,
        hasMultipleSlides,
        effect: 'fade',
        crossFade: true,
        rewind: hasMultipleSlides,
        allowTouchMove: hasMultipleSlides,
        autoplayRequested,
        autoplayEnabled: autoplayRequested && !prefersReducedMotion,
        autoplayDelay: clampInteger(autoplayDelay, 3000, 15000, 5500),
        transitionDuration: prefersReducedMotion
            ? 0
            : clampInteger(transitionDuration, 300, 2000, 900),
        pauseOnHover: autoplayRequested && parseBoolean(pauseOnHover, true),
        reducedMotion: prefersReducedMotion,
    };
};
